<span *ngFor="let label of labels" [ngClass]="label.color">{{label.name}}</span>